import request from './request'

/** POST `/api/admin/care-order/create-follow-up` 请求体（raw-json） */
export interface CreateFollowUpRequest {
  /** 检查项主键 */
  order_item_id: number
  /** 问题等级，如 `major` */
  issue_level: string
  /** Follow-up 业务 ID */
  follow_up_id?: string
  notes: string
}

export interface CreateFollowUpResponse {
  code: number
  msg: string
  data?: unknown
}

/**
 * 创建 Follow-up 订单。
 * Header `token` 由 `request` 拦截器从 localStorage 自动注入。
 */
export async function postCreateFollowUp(
  body: CreateFollowUpRequest,
): Promise<CreateFollowUpResponse> {
  const raw = await request.post<CreateFollowUpResponse>(
    '/api/admin/care-order/create-follow-up',
    {
      order_item_id: body.order_item_id,
      issue_level: body.issue_level,
      follow_up_id: body.follow_up_id,
      notes: body.notes,
    },
  )
  if (raw?.code === 200) return raw
  const msg =
    typeof raw?.msg === 'string' && raw.msg.trim() ? raw.msg : 'Failed to create follow-up'
  throw new Error(msg)
}
